import { gql } from 'graphql-request'

class ChatQueries {
  getToken = gql`
    query chatToken($itentityType: IdentityTypeEnum = CUSTOMER_USER) {
      chatToken(identityType: $itentityType)
    }
  `
}

const chatQueries = new ChatQueries()

export default chatQueries
